export default __webpack_public_path__ + "static/media/2829 knife block B side.fb205075.png";